import gql from 'graphql-tag';

export class TagQueries {
  static load = gql`
    query tags {
      tags {
        title
        status
        id
      }
    }
  `;
}
